import createVuexEntities from '@sbvr/common/legacy-shared/orm/plugin/vuex-entities';
import schema from './schema';

export default [createVuexEntities(schema)];
